import { CustomPageHeader } from '@src/components';
import { useEffect } from 'react';
import { Text } from '@src/components';
import { useDispatch } from 'react-redux';
import CurrentAccount from './CurrentAccount';

const Current = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [dispatch]);

    return (
        <CustomPageHeader
            data-testid="current-account"
            title={<Text t="currentAccountReport" />}
            showBreadCrumb
            showHelpButton
            routes={['Ticket Restaurant', 'Raporlar']}
        >
            <CurrentAccount />
        </CustomPageHeader>
    );
};

export default Current;
